import api from './api';

export const taskCommentApi = {
  // Lista comentários de uma tarefa
  list: (taskId, params = {}) => {
    return api.get('/task-comments', {
      params: { taskId, ...params }
    });
  },

  // Cria um novo comentário
  create: (data) => {
    return api.post('/task-comments', data);
  },

  // Atualiza um comentário
  update: (id, data) => {
    return api.put(`/task-comments/${id}`, data);
  },

  // Deleta um comentário
  delete: (id) => {
    return api.delete(`/task-comments/${id}`);
  },

  // Busca um comentário específico
  show: (id) => {
    return api.get(`/task-comments/${id}`);
  }
};